import { api } from "@";

// Function to get users with pagination
export const getUsers = (page = 1, perSize = "") =>
  api.get(`/api/AdminAffiliate/all?Page=${page}&PageSize=${perSize}`);

// Function to save user data (create or update)
export const saveUser = (data) => {
  // Update existing user
  if (data.id) {
    return api.put(`/api/AdminAffiliate/update/${data?.id}`, {
      name: data.name,
      email: data.email,
      phoneNumber: data.phone,
      password: data.password,
    });
  }
  // Create new user
  return api.post("/api/AdminAffiliate/create", data);
};
